export default __webpack_public_path__ + "static/media/controlMenu24.53ec28f5.svg";